module.exports = __webpack_public_path__ + "static/img/logo_250x250.4239196.png";


//////////////////
// WEBPACK FOOTER
// ../easytitle24-2.x-common/img/logo_250x250.png
// module id = hI5h
// module chunks = 0